import Component from './no-data.vue';
export default Component;
